import { AxiosInstance } from 'axios'

import { HandleRequestsFunctions } from '@shared/clients/http/commons/HandleRequestFunctions'
import { HandleResponseFunctions } from '@shared/clients/http/commons/HandleResponseFunctions'
import { ClientConfigProps } from '@shared/clients/types'
import { Languages } from '@shared/constants/Languages'
import { Storage } from '@shared/constants/Storage'

import { CustomAxiosInstance } from '../commons/CustomAxiosInstance'

class Config {
  private axios: AxiosInstance

  constructor({ apiUrl }: ClientConfigProps) {
    if (!apiUrl) throw new Error('Missing companies api url')

    this.axios = CustomAxiosInstance.createInstance(apiUrl, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Accept-Language': localStorage.getItem(Storage.LANGUAGE) ?? Languages.PT_BR,
      },
    })

    this.axios.interceptors.request.use(
      (request) => HandleRequestsFunctions.handleRequest(request),
      (error) => error,
    )

    this.axios.interceptors.response.use(
      (response) => response,
      (error) => HandleResponseFunctions.handleResponseError(error),
    )
  }

  instance(): AxiosInstance {
    return this.axios
  }
}

export const companiesApiConfig = (props: ClientConfigProps): Config => new Config(props)
